export const categories = [
    { name: "SUB 14 FEMENINO" },
    { name: "SUB 16 FEMENINO" },
    { name: "SUB 16 MASCULINO" },
    { name: "MAXIVOLEY" }
];